import React from "react";
import { Form, Button, Modal } from "react-bootstrap";

import courseDisciplinesService from "presentation/services/course-disciplines";
import evaluationResultLabelsService from "presentation/services/evaluation-result-labels";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import CancelButton from "presentation/components/buttons/cancel";

import { handleChange } from "presentation/utils/functions/generic";

class ManageDisciplineModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      actionLoading: false,
      error: false,
      message: '',
      data: [],
      evaluationResultLabels: [],
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    const { discipline } = this.props;
    await evaluationResultLabelsService.findAll().then((result) => {

      this.setState({ evaluationResultLabels: result, form: discipline, loading: false });
    });
  }

  handleSubmit = async () => {
    let { courseId, onClose, loadData } = this.props;
    this.setState({ loading: true, actionLoading: true, error: '' });

    let postData = this.state.form;
    try {
      const response = await courseDisciplinesService.update(postData);
      if (response.error == true) {
        this.setState({
          loading: false,
          error: true,
          message: response.message
        });
      } else {
        this.setState({
          loading: false,
          error: '',
        }, () => {
          onClose();
          loadData(courseId);
        });

      }
    } catch (err) {
      this.setState({
        loading: false,
        actionLoading: false,
        error: true,
        message: err.message
      });
    }
  };

  render() {
    let { show, onClose, discipline } = this.props;
    let { loading, error, message, actionLoading, form, evaluationResultLabels } = this.state;
    let { handleSubmit } = this;
    let component = this;

    return (
      <Modal backdrop="static" show={show || false} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{discipline.discipline.displayName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
          {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
          {loading === false && (
            <Form>
              <div className="form mt-2">
                <Form.Label htmlFor="totalScheduledHours">Carga horária</Form.Label>
                <Form.Control
                  type="text"
                  id="totalScheduledHours"
                  name="totalScheduledHours"
                  defaultValue={form.totalScheduledHours}
                  onChange={(e) => handleChange(e, component)}
                  aria-describedby="totalScheduledHoursHelpBlock"
                />
                <Form.Text id="totalScheduledHoursHelpBlock" muted>
                  Informe o total da carga horária (opicional)
                </Form.Text>
              </div>
              <div className="form mt-2">
                <Form.Label htmlFor="ignoredInEvaluationSchemeCriterias">Opções de avaliação</Form.Label>
                <Form.Check
                  type="checkbox"
                  id="ignoredInEvaluationSchemeCriterias"
                  name="ignoredInEvaluationSchemeCriterias"
                  label={"Essa disciplina não reprova"}
                  checked={form.ignoredInEvaluationSchemeCriterias}
                  onChange={(e) => handleChange(e, component)}
                />
              </div>
              <div className="form mt-2">
                <Form.Label htmlFor="discipline">Rótulo de resultado</Form.Label>
                <Form.Select
                  aria-label="Rótulo de resultado"
                  defaultValue={form.evaluationResultLabelId}
                  id="evaluationResultLabelId"
                  name="evaluationResultLabelId"
                  onChange={(e) => handleChange(e, component)}
                  aria-describedby="evaluationResultLabelIdHelpBlock"
                >
                  <option value="-1">Sem rótulo</option>
                  {evaluationResultLabels.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                </Form.Select>
                <Form.Text id="evaluationResultLabelIdHelpBlock" muted>
                  Defina a qual rótulo de resultado dessa disciplina
                </Form.Text>
              </div>
            </Form>
          )
          }
        </Modal.Body>
        <Modal.Footer>
          <CancelButton
            containerProps={{
              disabled: loading,
              onClick: onClose
            }}
          />
          <Button disabled={loading} variant="success" className="float-end" onClick={() => handleSubmit()}>Salvar</Button>
        </Modal.Footer>
      </Modal>
    );
  };
}

export default ManageDisciplineModal;
